import { useStaticQuery, graphql } from 'gatsby';

export const useLocalizedLogoRibbon = selectedLocale => {
  const {
    allPrismicLogoRibbon: { edges: logoRibbons },
  } = useStaticQuery(graphql`
    query {
      allPrismicLogoRibbon {
        edges {
          node {
            ...LogoRibbonFragment
          }
        }
      }
    }
  `);

  return logoRibbons.filter(({ node }) => node.lang === selectedLocale);
};
